import { examResultsEndpoints } from "@/constants";
import { LanguageEnum } from "@/enums";
import { axiosClient } from "@/services/axios-client";
import type { ProcessExamRequestType, ProcessExamResponseType } from "@/types";

type ApiProcessEnvelopeType = {
    data: {
        estimated_time_seconds: number,
        isCached?: boolean,
        job_id: string,
        status_url: string,
    },
    isSuccess: boolean,
    message: string,
};

export const processExamHandler = async ({
    examCode,
    lang,
}: ProcessExamRequestType): Promise<ProcessExamResponseType> => {
    const url = lang === LanguageEnum.AR ? `${examResultsEndpoints.process}?lang=${LanguageEnum.AR}` : examResultsEndpoints.process;

    const headers = lang === LanguageEnum.AR ? { "Accept-Language": LanguageEnum.AR } : undefined;

    const payload = { examCode: examCode };  

    const response = await axiosClient.post<ApiProcessEnvelopeType>(
        url,
        payload,
        { headers },
    );

    const { data } = response.data;

    return {
        cached: data.isCached ?? false,
        estimatedTimeSeconds: data.estimated_time_seconds,
        jobId: data.job_id,
        statusUrl: data.status_url,
    };
};
